"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StickyBanner;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _StickyBannerModule = _interopRequireDefault(require("./StickyBanner.module.scss"));
var _imageWrapper = _interopRequireDefault(require("../../imageWrapper/imageWrapper"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function StickyBanner(props) {
  var stickyBannerBackgroundColour = props.stickyBannerBackgroundColour,
    stickyBannerCtaGroup = props.stickyBannerCtaGroup,
    stickyBannerLogos = props.stickyBannerLogos,
    StickyBannerCopy = props.StickyBannerCopy;
  var stickyBannerCtas = stickyBannerCtaGroup && stickyBannerCtaGroup.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_StickyBannerModule["default"].bannerCtaGroup, _defineProperty({}, _StickyBannerModule["default"].hasTwoCtas, (stickyBannerCtaGroup === null || stickyBannerCtaGroup === void 0 ? void 0 : stickyBannerCtaGroup.length) > 1)),
    children: stickyBannerCtaGroup
  });
  var bannerLogos = stickyBannerLogos === null || stickyBannerLogos === void 0 ? void 0 : stickyBannerLogos.map(function (logo, index) {
    var _logo$imageAlt;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_imageWrapper["default"], {
      className: _StickyBannerModule["default"].logo,
      altText: (_logo$imageAlt = logo.imageAlt) !== null && _logo$imageAlt !== void 0 ? _logo$imageAlt : '',
      desktop: logo.desktopUrl,
      mobile: logo.mobileUrl
    }, "button ".concat(index + 1));
  });
  var htmlContent = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _StickyBannerModule["default"].copy,
    children: StickyBannerCopy
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _StickyBannerModule["default"].stickyBanner,
    "data-testid": "sticky-banner",
    style: stickyBannerBackgroundColour && {
      backgroundColor: stickyBannerBackgroundColour
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _StickyBannerModule["default"].bannerContainer,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _StickyBannerModule["default"].leftSection,
        children: stickyBannerCtas
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _StickyBannerModule["default"].rightSection,
        children: [bannerLogos, htmlContent]
      })]
    })
  });
}